import { render, staticRenderFns } from "./VimeoVideo.vue?vue&type=template&id=6f55b507&scoped=true&"
import script from "./VimeoVideo.vue?vue&type=script&lang=ts&"
export * from "./VimeoVideo.vue?vue&type=script&lang=ts&"
import style0 from "./VimeoVideo.vue?vue&type=style&index=0&id=6f55b507&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f55b507",
  null
  
)

export default component.exports